import toys from '../toys.json';
import filtersData from '../toys-description.json';

const toyAssets = import.meta.glob('../img/our-toys/*.{webp,png,jpg,jpeg,svg}', {
  eager: true,
  import: 'default',
});

const iconAssets = import.meta.glob('../img/toys/icons/*.{svg,png,webp}', {
  eager: true,
  import: 'default',
});

const toysList = document.querySelector('.our-toys-list');
const loadMoreBtn = document.getElementById('loadMoreBtn');
const filterDescription = document.getElementById('toysFilterDescription');

const ITEMS_PER_CLICK = 6;
const CATALOG_LINK = 'https://t.me/+i-yrLCy3CmQyMjhi';

let allToys = toys;
let currentFilter = 'all';
let visibleCount = ITEMS_PER_CLICK;

function getToyAsset(fileName) {
  return toyAssets[`../img/our-toys/${fileName}`] || '';
}

function getIconAsset(fileName) {
  return iconAssets[`../img/toys/icons/${fileName}`] || '';
}

function renderFilters() {
  const filtersContainer = document.getElementById('toysFilters');
  const dropdownList = document.querySelector('.filters-dropdown-list');

  if (!filtersContainer || !dropdownList) return;

  filtersContainer.innerHTML = filtersData
    .map(
      filter => `
        <button
          class="toy-filter-btn ${
            filter.value === 'all' ? 'active-filter' : ''
          }"
          data-filter="${filter.value}"
          type="button"
        >
          ${filter.label}
        </button>
      `
    )
    .join('');

  dropdownList.innerHTML = filtersData
    .map(
      filter => `
        <li
          class="filters-dropdown-item ${
            filter.value === 'all' ? 'active-filter' : ''
          }"
          data-value="${filter.value}"
          tabindex="0"
        >
          ${filter.label}
        </li>
      `
    )
    .join('');
}

function updateFilterDescription(filterValue) {
  const activeFilter = filtersData.find(item => item.value === filterValue);

  if (!filterDescription || !activeFilter) return;

  if (!Array.isArray(activeFilter.description)) {
    filterDescription.textContent = activeFilter.description || '';
    return;
  }

  filterDescription.innerHTML = activeFilter.description
    .map(paragraph => {
      const before = paragraph.before || '';
      const strong = paragraph.strong || '';
      const after = paragraph.after || '';
      const text = paragraph.text || '';

      if (strong || before || after) {
        return `
          <p class="our-toys-filter-paragraph">
            ${before}${strong ? `<strong>${strong}</strong>` : ''}${after}
          </p>
        `;
      }

      return `
        <p class="our-toys-filter-paragraph">
          ${text}
        </p>
      `;
    })
    .join('');
}

function createToyCard(toy) {
  const li = document.createElement('li');
  li.className = 'our-toys-item';
  li.dataset.category = toy.categorySlug;

  const image1x = getToyAsset(`${toy.id}-d.webp`);
  const image2x = getToyAsset(`${toy.id}-d@2x.webp`);
  const image3x = getToyAsset(`${toy.id}-d@3x.webp`);

  const buyIconMobile = getIconAsset('buy-icon.svg');
  const buyIconDesktop = getIconAsset('arrow-icon.svg');

  const srcset = [image1x && `${image1x} 1x`, image2x && `${image2x} 2x`, image3x && `${image3x} 3x`]
    .filter(Boolean)
    .join(', ');

  li.innerHTML = `
    <div class="our-toys-thumb">
      <div class="our-toys-wrapper">
        <picture>
          ${
            srcset
              ? `
            <source
              srcset="${srcset}"
              type="image/webp"
            />
          `
              : ''
          }
          <img
            loading="lazy"
            class="our-toys-img"
            src="${image1x}"
            alt="${toy.name}"
          />
        </picture>

        <div class="our-toys-content-wrapper">
          <div class="our-toys-container">
            <h3 class="our-toys-subtitle">${toy.name}</h3>
            <p class="our-toys-text">
              <span class="our-toys-meta-label">Матеріал:</span>
              <span class="our-toys-meta-value">${toy.material}</span>
            </p>
            <p class="our-toys-text">
              <span class="our-toys-meta-label">Вік дитини:</span>
              <span class="our-toys-meta-value">${toy.age}</span>
            </p>
            <p class="our-toys-text">
              <span class="our-toys-meta-label">Категорія:</span>
              <span class="our-toys-meta-value">${toy.category}</span>
            </p>
          </div>

          <div class="our-toys-actions">
            <button
              type="button"
              class="buy-btn-modal our-toys-action-btn our-toys-action-btn-primary"
              aria-label="Замовити ${toy.name}"
            >
              <span class="our-toys-action-btn-text">Замовити</span>

              <span class="our-toys-action-btn-icon" aria-hidden="true">
                <img
                  class="our-toys-action-btn-icon-mobile"
                  src="${buyIconMobile}"
                  alt=""
                  width="24"
                  height="24"
                />
                <img
                  class="our-toys-action-btn-icon-desktop"
                  src="${buyIconDesktop}"
                  alt=""
                  width="24"
                  height="24"
                />
              </span>
            </button>

            <a
              href="${CATALOG_LINK}"
              class="our-toys-action-btn our-toys-action-btn-secondary"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span class="our-toys-action-btn-text">Каталог</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  `;

  return li;
}

function getFilteredToys() {
  return allToys.filter(toy => {
    return currentFilter === 'all' || toy.categorySlug === currentFilter;
  });
}

function renderToys() {
  if (!toysList) return;

  const filteredToys = getFilteredToys();
  toysList.innerHTML = '';

  filteredToys.slice(0, visibleCount).forEach(toy => {
    toysList.appendChild(createToyCard(toy));
  });

  if (loadMoreBtn) {
    loadMoreBtn.style.display =
      filteredToys.length > visibleCount ? 'flex' : 'none';
  }
}

function setFilter(filterValue) {
  currentFilter = filterValue;
  visibleCount = ITEMS_PER_CLICK;

  document.querySelectorAll('.toy-filter-btn[data-filter]').forEach(button => {
    button.classList.toggle(
      'active-filter',
      button.dataset.filter === filterValue
    );
  });

  document.querySelectorAll('.filters-dropdown-item').forEach(item => {
    item.classList.toggle('active-filter', item.dataset.value === filterValue);
  });

  const selectedFilter = filtersData.find(item => item.value === filterValue);
  const dropdownValue = document.querySelector('.filters-dropdown-value');

  if (selectedFilter && dropdownValue) {
    dropdownValue.textContent = selectedFilter.label;
  }

  updateFilterDescription(filterValue);
  renderToys();
}

function initFilterEvents() {
  document.addEventListener('click', event => {
    const filterButton = event.target.closest('.toy-filter-btn[data-filter]');
    const dropdownTrigger = event.target.closest('.filters-dropdown-trigger');
    const dropdownItem = event.target.closest('.filters-dropdown-item');
    const dropdown = document.getElementById('toysCustomSelect');

    if (filterButton) {
      setFilter(filterButton.dataset.filter);
      return;
    }

    if (dropdownTrigger && dropdown) {
      const isOpen = dropdown.classList.toggle('is-open');
      dropdownTrigger.setAttribute('aria-expanded', String(isOpen));
      return;
    }

    if (dropdownItem && dropdown) {
      setFilter(dropdownItem.dataset.value);
      dropdown.classList.remove('is-open');
      dropdown
        .querySelector('.filters-dropdown-trigger')
        ?.setAttribute('aria-expanded', 'false');
      return;
    }

    if (dropdown && !dropdown.contains(event.target)) {
      dropdown.classList.remove('is-open');
      dropdown
        .querySelector('.filters-dropdown-trigger')
        ?.setAttribute('aria-expanded', 'false');
    }
  });
}

if (loadMoreBtn) {
  loadMoreBtn.addEventListener('click', () => {
    visibleCount += ITEMS_PER_CLICK;
    renderToys();
  });
}

renderFilters();
initFilterEvents();
setFilter('all');